import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../../../../../reactive/com/lightningkite/reactive/core/abstracts.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from '../../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function vprop(_this__u8e3s4, eventName, get, set) {
  return vprop$1().ucq(_this__u8e3s4, eventName, get, set);
}
function vevent(_this__u8e3s4, eventName) {
  return vevent$1().wcq(_this__u8e3s4, eventName);
}
var vprop$1Class;
function vprop$1() {
  if (vprop$1Class === VOID) {
    class $ extends BaseListenable() {
      static ucq($this_vprop, $eventName, $get, $set, $box) {
        if ($box === VOID)
          $box = {};
        $box.rcq_1 = $this_vprop;
        $box.scq_1 = $get;
        $box.tcq_1 = $set;
        var $this = this.uam($box);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = $this_vprop.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener($eventName, (it) => {
            $this.mal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = $this_vprop.gb4_1['on' + $eventName];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + $eventName;
          $this_vprop.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.mal();
            return Unit_instance;
          };
        }
        return $this;
      }
      xcq(value) {
        this.tcq_1(this.rcq_1, value);
        this.mal();
      }
      oam(_set____db54di) {
        return this.xcq((_set____db54di == null ? true : !(_set____db54di == null)) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.scq_1(this.rcq_1);
      }
      ycq(value, $completion) {
        this.tcq_1(this.rcq_1, value);
        this.mal();
      }
      iah(value, $completion) {
        return this.ycq((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).sah = get_state;
    initMetadataForClass($, VOID, VOID, VOID, [MutableReactiveValue(), BaseListenable()], [1]);
    vprop$1Class = $;
  }
  return vprop$1Class;
}
var vevent$1Class;
function vevent$1() {
  if (vevent$1Class === VOID) {
    class $ extends BaseListenable() {
      static wcq($this_vevent, $eventName) {
        var $this = this.uam();
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var tmp0_safe_receiver = $this_vevent.xb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener($eventName, (it) => {
            $this.mal();
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = $this_vevent.gb4_1['on' + $eventName];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + $eventName;
          $this_vevent.gb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            $this.mal();
            return Unit_instance;
          };
        }
        return $this;
      }
    }
    initMetadataForClass($);
    vevent$1Class = $;
  }
  return vevent$1Class;
}
//region block: exports
export {
  vevent as vevent2d70lzbz6q2i1,
  vprop as vpropka48um9uweps,
};
//endregion

//# sourceMappingURL=helpers.commonHtml.mjs.map
